import { lazy } from 'react';
const Autumn = lazy(() => import(
// webpackChunkName: 'Autumn'
'./icons/autumn.svg'));
const Comfort = lazy(() => import(
// webpackChunkName: 'Comfort'
'./icons/comfort.svg'));
const Day = lazy(() => import(
// webpackChunkName: 'Day'
'./icons/day.svg'));
const Economy = lazy(() => import(
// webpackChunkName: 'Economy'
'./icons/economy.svg'));
const Night = lazy(() => import(
// webpackChunkName: 'Night'
'./icons/night.svg'));
const Off = lazy(() => import(
// webpackChunkName: 'Off'
'./icons/off.svg'));
const Out = lazy(() => import(
// webpackChunkName: 'Out'
'./icons/out.svg'));
const Personal = lazy(() => import(
// webpackChunkName: 'Personal'
'./icons/personal.svg'));
const Schedule = lazy(() => import(
// webpackChunkName: 'Schedule'
'./icons/schedule.svg'));
const Spring = lazy(() => import(
// webpackChunkName: 'Spring'
'./icons/spring.svg'));
const Summer = lazy(() => import(
// webpackChunkName: 'Summer'
'./icons/summer.svg'));
const Vacation = lazy(() => import(
// webpackChunkName: 'Vacation'
'./icons/vacation.svg'));
const Winter = lazy(() => import(
// webpackChunkName: 'Winter'
'./icons/winter.svg'));
export const custom_heating_modes_icons = [
    {
        id: 0,
        render: null,
        title: [''],
    },
    {
        id: 1,
        render: Autumn,
        title: ['Осень', 'Осенний'],
    },
    {
        id: 2,
        render: Comfort,
        title: ['Комфорт', 'Комфортный'],
    },
    {
        id: 3,
        render: Day,
        title: ['День', 'Дневной'],
    },
    {
        id: 4,
        render: Economy,
        title: ['Эконом', 'Экономичный'],
    },
    {
        id: 5,
        render: Night,
        title: ['Ночь', 'Ночной'],
    },
    {
        id: 6,
        render: Off,
        title: ['Выключен', 'Off', 'Выкл', 'Выключено', 'Выключить'],
    },
    {
        id: 7,
        render: Out,
        title: ['Отсутствие', 'Никого нет дома'],
    },
    {
        id: 8,
        render: Personal,
        title: ['Персональный'],
    },
    {
        id: 9,
        render: Schedule,
        title: ['Расписание'],
    },
    {
        id: 10,
        render: Spring,
        title: ['Весна', 'Весенний'],
    },
    {
        id: 11,
        render: Summer,
        title: ['Лето', 'Летний'],
    },
    {
        id: 12,
        render: Vacation,
        title: ['Отпуск'],
    },
    {
        id: 13,
        render: Winter,
        title: ['Зима', 'Зимний'],
    },
];
export const autoHeatingModeIcon = (mode_name) => {
    const finded_icon = custom_heating_modes_icons.find((icon) => icon.title
        .map((el) => el.toLowerCase())
        .includes(mode_name.toLowerCase().replace(/[ ]+$/g, '')));
    if (!finded_icon) {
        return custom_heating_modes_icons[0];
    }
    return finded_icon;
};
